import { Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, IconButton, Tooltip, Button } from '@mui/material'
import { IDataDetalharCooperado } from '../../../../../../../types/api/cadastros/detalhar-cooperado';
import { useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import TrashIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import DialogEditarRelacionamento from './components/DialogEditarRelacionamento';
import DialogIncluirRelacionamento from './components/DialogIncluirRelacionamento';
import { formatarCPFCNPJ, formatarTelefone } from '../../../../../../../helpers/masks';
import { useMutation, useQueryClient } from 'react-query';
import axiosClient from '../../../../../../../lib/axios';
import { useSnackbar } from 'notistack';

interface PropsCardRelacionamento {
  data: IDataDetalharCooperado;
}

export default function CardRelacionamento({
  data
}: PropsCardRelacionamento) {

  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const [selectedRelacionamento, setSelectedRelacionamento] = useState(null);
  const [includeModalOpen, setIncludeModalOpen] = useState<boolean>(false);

  const handleEdit = (relacionamento: any) => {
    setSelectedRelacionamento(relacionamento);
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setSelectedRelacionamento(null);
  };

  const handleInclude = () => {
    setIncludeModalOpen(true);
  };

  const handleCloseIncludeModal = () => {
    setIncludeModalOpen(false);
  };


  const { mutate: deleteRelacionamento } = useMutation({
    mutationFn: (id: string) => axiosClient.delete(`cadastros/excluir-relacionamento/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries('cadastros/detalhar-cooperado')
      enqueueSnackbar("Relacionamento excluído com sucesso!", { variant: "success" });
    },
  });

  const handleDelete = (id: number) => {
    deleteRelacionamento(id.toString());
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6">
          Relacionamentos
        </Typography>
        <TableContainer>
          <Table size="small" aria-label="tabela simples">
            <TableHead>
              <TableRow>
                <TableCell><b>Nome</b></TableCell>
                <TableCell><b>Documento</b></TableCell>
                <TableCell><b>Sexo</b></TableCell>
                <TableCell><b>Grau Parentesco</b></TableCell>
                <TableCell><b>Tipo Relacionamento</b></TableCell>
                <TableCell><b>Telefone</b></TableCell>
                <TableCell align="center"><b>Ações</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.relacionamentos.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.nome || 'Não informado'}
                  </TableCell>
                  <TableCell>
                    {formatarCPFCNPJ(row.documento) || 'Não informado'}
                  </TableCell>
                  <TableCell>
                    {row.sexo || 'Não informado'}
                  </TableCell>
                  <TableCell>
                    {row.grau_parentesco || 'Não informado'}
                  </TableCell>
                  <TableCell>
                    {row.tipo_relacionamento || 'Não informado'}
                  </TableCell>
                  <TableCell>
                    {formatarTelefone(row.telefone) || 'Não informado'}
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="Editar Relacionamento">
                      <IconButton
                        onClick={() => handleEdit(row)}
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Excluir Relacionamento">
                      <IconButton
                        onClick={() => handleDelete(row.id)}
                      >
                        <TrashIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={handleInclude}
            size="small"
          >
            Adicionar
          </Button>
        </div>
      </CardContent>

      <DialogEditarRelacionamento
        open={editModalOpen}
        onClose={handleCloseEditModal}
        data={selectedRelacionamento}
        cooperadoId={data.id}
      />
      <DialogIncluirRelacionamento
        open={includeModalOpen}
        onClose={handleCloseIncludeModal}
        cooperadoId={data.id}
      />
    </Card>
  )
}